import { create } from "../../../../../common/utils/zustand_state_manager";
import { SetFunction, SetFunctionImpl } from "../../../../../common/utils/filters_utils";
/**
 * useFolhaPagamentoCadastroFilters
 */

type State = {
  idCentroCusto: number | null;
  idFuncionario: number | null;
};

type Actions = {
  setIdCentroCusto: SetFunction<number | null>;
  setIdFuncionario: SetFunction<number | null>;
  clearFilters: () => void;
};

export const useFolhaPagamentoCadastroFilters = create<State & Actions>((set) => ({
  idCentroCusto: null,
  idFuncionario: null,
  centroCustos: undefined,
  funcionarios: undefined,
  funcionariosCadastro: undefined,
  subcontas: undefined,
  setIdCentroCusto: vfn => SetFunctionImpl(set, 'idCentroCusto', vfn),
  setIdFuncionario: vfn => SetFunctionImpl(set, 'idFuncionario', vfn),
  clearFilters: () => set({
    idCentroCusto: null,
    idFuncionario: null,
  }),
}));